import { gql } from '@apollo/client'

export const MUTATION_ADD_TAGS_FOR_RENTALS = gql`
  mutation mutationAddTagsForRentals($input: AddTagsForRentalsInput!) {
    addTagsForRentals(input: $input) {
      items {
        id
        color
        name
        taggable_id
        taggable_type
      }
    }
  }
`
